/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type DataImportDetail,
    DataImportDetailFromJSON,
    DataImportDetailToJSON,
} from '../models/DataImportDetail';
import {
    type PaginatedDataImportList,
    PaginatedDataImportListFromJSON,
    PaginatedDataImportListToJSON,
} from '../models/PaginatedDataImportList';

export interface DataImportListRequest {
    importType?: DataImportListImportTypeEnum;
    ordering?: string;
    page?: number;
    pageSize?: number;
    status?: DataImportListStatusEnum;
}

export interface DataImportRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class DataImportApi extends runtime.BaseAPI {

    /**
     * Creates request options for dataImportList without sending the request
     */
    async dataImportListRequestOpts(requestParameters: DataImportListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['importType'] != null) {
            queryParameters['import_type'] = requestParameters['importType'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/data-import/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Viewset for the DataImport model.
     */
    async dataImportListRaw(requestParameters: DataImportListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataImportList>> {
        const requestOptions = await this.dataImportListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataImportListFromJSON(jsonValue));
    }

    /**
     * Viewset for the DataImport model.
     */
    async dataImportList(requestParameters: DataImportListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataImportList> {
        const response = await this.dataImportListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dataImportRetrieve without sending the request
     */
    async dataImportRetrieveRequestOpts(requestParameters: DataImportRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling dataImportRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/data-import/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Viewset for the DataImport model.
     */
    async dataImportRetrieveRaw(requestParameters: DataImportRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataImportDetail>> {
        const requestOptions = await this.dataImportRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataImportDetailFromJSON(jsonValue));
    }

    /**
     * Viewset for the DataImport model.
     */
    async dataImportRetrieve(requestParameters: DataImportRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataImportDetail> {
        const response = await this.dataImportRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const DataImportListImportTypeEnum = {
    Emissions: 'EMISSIONS',
    EpaSep: 'EPA_SEP',
    ExtraData: 'EXTRA_DATA',
    Infrastructure: 'INFRASTRUCTURE',
    NonDetects: 'NON_DETECTS',
    Scenes: 'SCENES'
} as const;
export type DataImportListImportTypeEnum = typeof DataImportListImportTypeEnum[keyof typeof DataImportListImportTypeEnum];
/**
 * @export
 */
export const DataImportListStatusEnum = {
    Complete: 'COMPLETE',
    Created: 'CREATED',
    Error: 'ERROR',
    Importing: 'IMPORTING',
    ReadyForProcessing: 'READY_FOR_PROCESSING',
    TimedOut: 'TIMED_OUT',
    WaitingApproval: 'WAITING_APPROVAL'
} as const;
export type DataImportListStatusEnum = typeof DataImportListStatusEnum[keyof typeof DataImportListStatusEnum];
